export const GH = {
  colors: {
    bg: '#EDEDEF',
    surface: '#FFFFFF',
    card: '#FFFFFF',
    cardHover: '#F5F5F7',
    charcoal: '#1C1F23',
    charcoalDeep: '#141618',
    grey: '#6B7280',
    greyLight: '#4B5563',
    white: '#1C1F23',
    accent: '#6B7280',
    accentDark: '#4B5563',
    accentMuted: 'rgba(107,114,128,0.12)',
    accentGlow: 'rgba(107,114,128,0.20)',
    gold: '#4A7C6F',
    goldDark: '#3A6459',
    goldMuted: 'rgba(74,124,111,0.12)',
    borderDk: 'rgba(28,31,35,0.09)',
    borderMd: 'rgba(28,31,35,0.16)',
    surfaceLt: '#F0F0F2',
    surfaceMid: '#E4E5E8',
    mutedDk: 'rgba(28,31,35,0.52)',
    subDk: 'rgba(28,31,35,0.68)',
    success: '#22C55E',
    warning: '#F59E0B',
    error: '#EF4444',
    onDark: {
      heading: '#FFFFFF',
      body: 'rgba(255,255,255,0.72)',
      muted: 'rgba(255,255,255,0.55)',
      border: 'rgba(255,255,255,0.12)',
    },
  },
  fonts: {
    display: "'Space Grotesk', sans-serif",
    body: "'DM Sans', sans-serif",
  },
};
